import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import { Image, Col, Form, Button, Row } from "react-bootstrap";
import {
  TextField,
  FormControl,
  Select,
  InputLabel,
  MenuItem,
} from "@material-ui/core";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import SelectFilter from "../../../reusableComponents/selectFilter";
import isEmpty from "../../../../store/validation/is-Empty";
import { getAllAdminRestaurantOffers } from "../../../../store/actions/SuperAdminActions/adminManageOffers";

const offerTypes = [
  { id: 0, title: "All" },
  { id: 1, title: "Online" },
  { id: 2, title: "Offline" },
];

const statusCode = [
  { id: 0, title: "All" },
  { id: 1, title: "Active" },
  { id: 2, title: "Inactive" },
];

export const OffersFilterSection = (props) => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [dateQuery, setDateQuery] = useState({
    startDate: moment().subtract(30, "days").format("YYYY-MM-DD"),
    endDate: moment().format("YYYY-MM-DD"),
  });
  const [startAction, setAction] = useState(false);

  const auth = useSelector((state) => {
    return !isEmpty(state.auth) ? state.auth.user : "";
  });

  const onDateChangeHandler = (data, type) => {
    setDateQuery(data);
  };

  useEffect(() => {
    if (!isEmpty(dateQuery)) {
      dispatch(
        getAllAdminRestaurantOffers(
          auth.accessToken,
          dateQuery.startDate,
          dateQuery.endDate,
          onSuccessGetResOffers,
          onErrorGetResOffers
        )
      );
      setAction(false);
    }
  }, [dateQuery]);

  const onSuccessGetResOffers = () => {
    setLoading(false);
  };

  const onErrorGetResOffers = () => {
    setLoading(false);
  };

  return (
    <React.Fragment>
      {}
      <>
        <div className="row super-admin-toptext-searchbar-icon">
          <div className="col-6">
            <div className="col-9 p-0">
              <Form.Control
                type="text"
                placeholder="Search by offer title, offer code"
                onChange={props.onChange}
                value={props.search}
                className="amSearch"
              />
            </div>
          </div>
          <div className="col-6">
            <div className="row justify-content-end align-items-center">
              <div className="col-5">
                <div className="mr-3">
                  <SelectFilter onDateChange={onDateChangeHandler} />
                </div>
              </div>
              <div className="col-3">
                <div className="d-flex align-items-center justify-content-between">
                  {props.sortMenuButton}
                  <div
                    className="f10-400"
                    align="center"
                    onClick={props.handleShowFilter}
                  >
                    <img
                      src={require("../../../../assets/images/iconButton/filtericon.png")}
                      width="35px"
                    />
                    <br />
                    Filter
                  </div>
  
                    {props.downButton}
                  
                </div>
              </div>
            </div>
          </div>
        </div>
        {props.showFilter && (
          <div className="row">
            <div className="col-12">
              <div className="enWhiteBox mt-3">
                <Form className="row justify-content-between">
                  {/* <Col md={5}>
                    <Form.Group>
                      <FormControl variant="outlined" className="w-100">
                        <InputLabel htmlFor="outlined-Status">
                          Status
                        </InputLabel>
                        <Select
                          value={props.status}
                          onChange={props.handleStatusChange}
                          label="Status"
                          inputProps={{
                            name: "Status",
                            id: "outlined-Status",
                          }}
                          IconComponent={KeyboardArrowDownIcon}
                        >
                          {statusCode.map((data) => {
                            return (
                              <option value={data.title} key={data.id}>
                                {data.title}
                              </option>
                            );
                          })}
                        </Select>
                      </FormControl>
                    </Form.Group>
                  </Col> */}
                  <Col md={5}>
                    <Form.Group>
                      <FormControl variant="outlined" className="w-100">
                        <InputLabel htmlFor="outlined-Offer">Offer</InputLabel>
                        <Select
                          value={props.offerType}
                          onChange={props.handleOfferTypeChange}
                          label="Offer"
                          inputProps={{
                            name: "Offer",
                            id: "outlined-Location",
                          }}
                          IconComponent={KeyboardArrowDownIcon}
                        >
                          {offerTypes.map((data) => {
                            return (
                              <option value={data.title} key={data.id}>
                                {data.title}
                              </option>
                            );
                          })}
                        </Select>
                      </FormControl>
                    </Form.Group>
                  </Col>

                  <Col md={12}>
                    <div className="d-flex align-items-center">
                      <Button
                        variant="outline-secondary"
                        className="btn-lg mr-4 px-5"
                        onClick={props.cancelClick}
                      >
                        Cancel
                      </Button>
                      <Button
                        variant="danger"
                        className="btn-lg px-5"
                        onClick={props.searchClick}
                      >
                        Search
                      </Button>
                    </div>
                  </Col>
                </Form>
              </div>
            </div>
          </div>
        )}
      </>
    </React.Fragment>
  );
};
